import TopbarNotificationsBell from './topbar/TopbarNotificationsBell.vue';

export default function registerUserNotificationsApVueComponents(app) {
    app.component('topbar-notifications-bell', TopbarNotificationsBell);
}
